import React from 'react';
import ConditionalWrapper from '../ConditionalWrapper/ConditionalWrapper';
import ContentConsent from '../../modules/ContentConsent/ContentConsent';
import { jsx as ___EmotionJSX } from "@emotion/react";
const ResponsiveIFrame = _ref => {
  let {
    src,
    title,
    maxHeight,
    consentNecessary,
    consentHeader,
    consentText,
    consentButton,
    type
  } = _ref;
  const consentKey = type ? type : `${title.toLowerCase().trim()}`;
  return ___EmotionJSX(ConditionalWrapper, {
    condition: consentNecessary,
    wrapper: children => ___EmotionJSX(ContentConsent, {
      consentId: consentKey,
      consentHeader: consentHeader,
      consentText: consentText,
      consentButton: consentButton,
      type: type
    }, children)
  }, ___EmotionJSX("div", {
    style: {
      position: 'relative',
      'width': '100%',
      paddingTop: `${maxHeight}%`
    }
  }, ___EmotionJSX("iframe", {
    src: src,
    frameBorder: "0",
    style: {
      border: '0',
      position: 'absolute',
      height: '100%',
      width: '100%',
      top: '0',
      left: '0'
    },
    allowFullScreen: true,
    title: title
  })));
};
ResponsiveIFrame.defaultProps = {
  maxHeight: 75,
  consentNecessary: true
};
export default ResponsiveIFrame;